"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPanRoomsByBuildingId = void 0;
var getPanRoomsByBuildingId_1 = __importDefault(require("./getPanRoomsByBuildingId"));
exports.getPanRoomsByBuildingId = getPanRoomsByBuildingId_1.default;
